import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import { useMediaQuery } from 'react-responsive';
import { autoUpdate, flip, offset, shift, arrow, useClick, useDismiss, useFloating, useInteractions, FloatingPortal, FloatingArrow } from '@floating-ui/react';
import { useState, useMemo, useRef, useCallback } from 'react';
import breakpoints from '@/config/breakpoints';
import design from '@/config/design';
import { Drawer, DrawerContent } from '@/components/FormElements/internal/Drawer';
import Switch from '@/components/FormElements/Switch';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var ArrowRightIcon = function ArrowRightIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.29286 6.29289C7.90234 6.68342 7.90234 7.31658 8.29286 7.70711L12.5858 12L8.29286 16.2929C7.90234 16.6834 7.90234 17.3166 8.29286 17.7071C8.68339 18.0976 9.31655 18.0976 9.70708 17.7071L15.4142 12L9.70708 6.29289C9.31655 5.90237 8.68339 5.90237 8.29286 6.29289Z",
      fill: "#12131A"
    })
  }));
};

ArrowRightIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const FieldsRevealPill = _ref => {
  let {
    label,
    elementId = '',
    open: controlledOpen,
    initialOpen = false,
    disableOpen = false,
    noPadding = false,
    arrowHidden = false,
    floatingArrowHidden = false,
    variant: srcVariant,
    openButtonVariant = 'pill',
    openButtonSize = 'medium',
    placement = 'bottom',
    leftIcon,
    activeState,
    classNames,
    children,
    OpenButton,
    onOpenChange
  } = _ref;
  const arrowRef = useRef(null);
  const {
    0: menuOpen,
    1: setMenuOpen
  } = useState(initialOpen);
  const isOpen = (controlledOpen ?? menuOpen) && !disableOpen; // Enable controlled handling of open states.

  const handleOpenChange = useCallback(open => {
    if (typeof onOpenChange === 'function') {
      onOpenChange(open);
    } else {
      setMenuOpen(open);
    }
  }, [onOpenChange]); // Create optional variant classes for container

  const variantClasses = useMemo(() => {
    const variants = Array.isArray(srcVariant) ? srcVariant : [srcVariant];
    return variants.filter(Boolean).map(variant => styles[`container--${variant}`]);
  }, [srcVariant]); // Handle menu positioning

  const {
    refs,
    floatingStyles,
    context
  } = useFloating({
    open: isOpen,
    onOpenChange: handleOpenChange,
    placement: placement,
    whileElementsMounted: autoUpdate,
    middleware: [offset(12), flip(), shift(), arrow({
      element: floatingArrowHidden ? null : arrowRef.current
    })]
  }); // Responsive queries

  const isMobile = useMediaQuery({
    maxWidth: breakpoints.mobile.maxWidth
  }); // open menu on button click

  const click = useClick(context); // close menu on outside click or escape key

  const dismiss = useDismiss(context, {
    enabled: !isMobile
  });
  const {
    getReferenceProps,
    getFloatingProps
  } = useInteractions([click, dismiss]);
  const OpenButtonElement = OpenButton || PillOpenButton;
  const showArrow = Boolean(children) && !arrowHidden && !disableOpen && openButtonVariant === 'compact';
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, elementId && {
    id: elementId
  }), {}, {
    className: clsx(styles.container, styles[`container--${openButtonVariant}`], classNames === null || classNames === void 0 ? void 0 : classNames.container, ...variantClasses),
    children: [/*#__PURE__*/_jsx(OpenButtonElement, {
      isOpen: isOpen,
      label: label,
      variant: openButtonVariant,
      size: openButtonSize,
      activeState: activeState,
      leftIcon: leftIcon,
      showArrow: showArrow,
      setReference: refs.setReference,
      getReferenceProps: getReferenceProps,
      onOpenChange: handleOpenChange
    }), children ? /*#__PURE__*/_jsx(PillContent, {
      isMobile: isMobile,
      menuOpen: isOpen,
      context: context,
      arrowRef: arrowRef,
      floatingStyles: floatingStyles,
      floatingArrowHidden: floatingArrowHidden,
      className: classNames === null || classNames === void 0 ? void 0 : classNames.floating,
      setFloating: refs.setFloating,
      getFloatingProps: getFloatingProps,
      onMenuOpenChange: handleOpenChange,
      children: /*#__PURE__*/_jsx("div", {
        className: clsx(styles.content, classNames === null || classNames === void 0 ? void 0 : classNames.content, {
          [styles['content--isMobile']]: isMobile,
          [styles['content--noPadding']]: noPadding
        }),
        children: children
      })
    }) : null]
  }));
};

const PillOpenButton = _ref2 => {
  let {
    label,
    variant,
    size,
    leftIcon,
    activeState,
    showArrow,
    setReference,
    getReferenceProps
  } = _ref2;
  return /*#__PURE__*/_jsxs("button", _objectSpread(_objectSpread({
    ref: setReference,
    type: "button",
    className: clsx(styles.heading, styles[`heading--${variant}`], styles[`heading--${size}`])
  }, getReferenceProps()), {}, {
    children: [leftIcon ? /*#__PURE__*/_jsx("span", {
      className: styles.heading__icon,
      children: leftIcon
    }) : null, /*#__PURE__*/_jsx("span", {
      className: styles.heading__text,
      children: label
    }), /*#__PURE__*/_jsx("span", {
      className: styles.heading__state,
      children: activeState
    }), /*#__PURE__*/_jsx("span", {
      className: clsx(styles.heading__arrow, {
        [styles['heading__arrow--active']]: showArrow
      }),
      children: showArrow ? /*#__PURE__*/_jsx(ArrowRightIcon, {}) : null
    })]
  }));
};

const PillContent = _ref3 => {
  let {
    isMobile,
    menuOpen,
    floatingStyles,
    arrowRef,
    context,
    className,
    floatingArrowHidden,
    children,
    setFloating,
    getFloatingProps,
    onMenuOpenChange
  } = _ref3;

  // render the menu as a Drawer on mobile
  if (isMobile) {
    return /*#__PURE__*/_jsx(Drawer, {
      open: menuOpen,
      onOpenChange: onMenuOpenChange,
      children: /*#__PURE__*/_jsx(DrawerContent, {
        children: children
      })
    });
  }

  if (!menuOpen) return /*#__PURE__*/_jsx(_Fragment, {});
  return (
    /*#__PURE__*/
    // ensure the floating element can appear outside any
    // potential parent containers that cause clipping
    _jsx(FloatingPortal, {
      children: /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
        ref: setFloating,
        className: clsx(styles.floating, className),
        style: floatingStyles
      }, getFloatingProps()), {}, {
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.floatingContent,
          children: children
        }), !floatingArrowHidden ? /*#__PURE__*/_jsx(FloatingArrow, {
          ref: arrowRef,
          context: context,
          className: styles.arrow,
          stroke: design.colors.gray30,
          strokeWidth: 1
        }) : null]
      }))
    })
  );
};

const PillSwitch = _ref4 => {
  let {
    checked,
    onChange
  } = _ref4;
  return /*#__PURE__*/_jsx(Switch, {
    label: null,
    checked: checked,
    onChange: (_, checked) => {
      onChange(checked);
    }
  });
};

const PillChip = _ref5 => {
  let {
    count = 0,
    content,
    className = ''
  } = _ref5;
  const countString = count > 99 ? '99+' : count;
  return /*#__PURE__*/_jsx("span", {
    className: clsx(styles.chip, className),
    children: content ?? countString
  });
};

const PillColor = _ref6 => {
  let {
    color,
    className
  } = _ref6;
  return /*#__PURE__*/_jsx("span", {
    className: clsx(styles.color, {
      [styles['color--transparent']]: color === 'transparent' || !color
    }, className),
    style: {
      background: color
    }
  });
};

export default FieldsRevealPill;
export { PillChip, PillColor, PillSwitch };